// A screen from the spec that the web app hasn't built yet. It shows what the
// screen is for, who can use it and which API calls it makes, straight from the
// spec, and links to its help, so the app's structure is complete and navigable.
import { Construction } from "lucide-react";
import { helpForScreen } from "../app/help";
import type { Screen } from "../app/screens";
import { DOMAIN_NAMES } from "../app/screens";
import { PageHeader } from "./PageHeader";

export function ScreenPlaceholder({ screen }: { screen: Screen }) {
  return (
    <div className="page">
      <PageHeader title={screen.title} subtitle={`${screen.id} · ${DOMAIN_NAMES[screen.domain] ?? screen.domain} · ${screen.phase}`} screenId={screen.id} />
      <section className="card placeholder">
        <Construction size={28} aria-hidden />
        <div>
          <h2>Not built yet</h2>
          <p>{screen.purpose}</p>
          <dl className="facts">
            {screen.who && (
              <>
                <dt>Who</dt>
                <dd>{screen.who}</dd>
              </>
            )}
            <dt>Layout</dt>
            <dd>{screen.archetype}</dd>
            {screen.loads && (
              <>
                <dt>Loads</dt>
                <dd>
                  <code>{screen.loads}</code>
                </dd>
              </>
            )}
          </dl>
          {screen.operations.length > 0 && (
            <>
              <h3>API operations</h3>
              <ul className="ops">
                {screen.operations.map((o) => (
                  <li key={`${o.method} ${o.path}`}>
                    <span className="method" data-method={o.method}>
                      {o.method}
                    </span>{" "}
                    <code>{o.path}</code> <span className="muted">{o.summary}</span>
                  </li>
                ))}
              </ul>
            </>
          )}
          <p>
            <a href={helpForScreen(screen.id)} target="_blank" rel="noopener">
              Read the help for this screen
            </a>
          </p>
        </div>
      </section>
    </div>
  );
}
